import CopyLinkButton from './CopyLinkButton';

export default CopyLinkButton;
